<script setup>
import { Modal, Icon,Input,Button,Select,ColorPickerDefault,MediaUploaderButton,Label } from '@components';
import { ref,onMounted,computed } from 'vue';

import {useSettings} from '@store/settings';  
const $settings = useSettings();

import{useSetup} from '@store/setup';  
const $setup = useSetup();

import { useRouter } from 'vue-router';
const router = useRouter();

import { validationCheck, regex } from '@utils';

const backButton = () => {
	router.push({name:'setup.availability'})
}

const nextButton = async() => {
   let { errors } = validationCheck([
      {
         condition: !$settings.business.full_logo_url,
         message: 'Full logo is required',
      },
   ]);
   if (errors) return

  await $settings.saveSettings()
  await $setup.saveSetupStep('finish')
   router.push({name:'setup.finish'})
}

const fonts = computed(() => {
   return Object.entries(prebook_admin.options.fonts).map(([key, value]) => {
      return {
         value: key,
         label: `<span style="font-family: '${value}' !important;">${key}</span>`
      };
   });
});

const formData = ref({
   brand_color:'#9E77ED',
   title_font:'#101828',
   subtitle_font:'#344054'
})

const onBrandColorChange= (value)=>{
   $settings.customizer.design.brand_color = value;
   $settings.customizer.design.button_background_color = value;
}

const selectedFont = computed(() => {
   // return $settings.customizer.design.font_family
   return $settings.options.fonts[$settings.customizer.design.font_family] || ''
}) 
</script>


<template>
   <Modal :progress="100" class="transition duration-100 bg-white" contentClass="!p-0">
      <template #header>
         <div
            class="px-8 py-5 border-b-[#EAECF0] border-b flex items-center justify-between shadow-[0px_3px_0px_0px_#eaecf0]">
            <Icon name="logoLight" size="56px" />
            <Icon @click="$setup.crossButton" class="cursor-pointer" name="xClose" size="30px"></Icon>
         </div>
      </template>

      <template #default>
         <div class="flex h-full">
            <div class="w-full md:w-[calc(100%-738px)] h-full mb-5">
               <div class="mt-[70px] max-w-[750px] m-auto px-8 lg:px-[48px]">
                  <div class="text-base font-medium text-[#101828]">General / <span class="font-bold">{{ $setup.isBusiness ? 'Business' : 'Individual' }}</span></div>
                  <div class="text-[30px] font-bold text-[#101828] mt-2">Brand</div>
                  <div class="text-base text-[#475467] mt-2">
                     {{ $setup.isBusiness ? 'Let clients recognize your business at a glance. Upload your logo to ensure a consistent and professional brand presence. You can always change this later.' : 'Let clients recognize you at a glance. You can always change this later.' }}
                  </div>

                  <div class="mt-10 relative">
                     <Icon name="arrowRight" size="18px" class="absolute top-1 left-[-30px] text-[#101828]"></Icon>
                     <div class="text-[#101828] text-[20px] font-medium">{{ $setup.isBusiness ? 'Upload your logo' : 'Upload your profile photo or logo'}}</div>
                     <div class="flex flex-col md:flex-row w-full gap-[48px] py-5 md:gap-12">
                        <div title="Ensure to upload 900px x 220px full logo for better quality">
                           <Label>Full Logo<div class="text-[#D92D20] inline-block">*</div></Label>
                           <MediaUploaderButton class="mt-3" name="full_logo_url" :crop="true" :ratio="0"
                              v-model="$settings.business.full_logo_url">
                              <div class="p-2 rounded-lg border border-[#B692F6] border-dashed w-[253px]">
                                 <Icon v-if="!$settings.business.full_logo_url" name="logoLight" height="68px" width="100%"
                                    class="text-[#101828]" />
                                 <img v-if="$settings.business.full_logo_url" :src="$settings.business.full_logo_url"
                                    class="w-full max-h-full " />
                              </div>
                              <p class="mt-3 text-[#6941C6] text-sm font-semibold">Upload</p>
                           </MediaUploaderButton>
                        </div>
                        <div title="Ensure to upload 320px x 320px logo for better quality">
                           <Label>Logo Icon</Label>
                           <MediaUploaderButton class="mt-3" name="logo_url" :crop="true" :ratio="1 / 1"
                              v-model="$settings.business.logo_url">
                              <div class="p-2 rounded-lg border border-[#B692F6] border-dashed w-fit">
                                 <Icon v-if="!$settings.business.logo_url" name="logomark" width="72px" height="68px"
                                    class="text-[#101828]" />
                                 <img v-if="$settings.business.logo_url" :src="$settings.business.logo_url"
                                    class="w-[72px] h-[68px]" />
                              </div>
                              <p class="mt-3 text-[#6941C6] text-sm font-semibold">Upload</p>
                           </MediaUploaderButton>
                        </div>
                     </div>
                  </div>
                  <div class="mt-[30px] relative">
                     <Icon name="arrowRight" size="18px" class="absolute top-1 left-[-30px] text-[#101828]"></Icon>
                     <div class="text-[#101828] text-[20px] font-medium">Set your typography</div>
                     <!-- <Select v-model="formData.typography" placeholder="Select typography"
                              :options="[{ label: 'Plus Jakarta Sans', value: 'Plus Jakarta Sans' }]" class="mt-5"></Select> -->
                     <Select v-model="$settings.customizer.design.font_family" :options="fonts" class="mt-5"></Select>
                  </div>
                  <div class="mt-[30px] relative setup-set-color">
                     <Icon name="arrowRight" size="18px" class="absolute top-1 left-[-30px] text-[#101828]"></Icon>
                     <div class="text-[#101828] text-[20px] font-medium">Set color</div>
                     <div class="grid grid-cols-1 md:grid-cols-3 gap-[30px] mt-5">
                        <div>
                           <div class="text-[#344054] text-sm font-medium">Brand Color</div>
                           <div
                              class="flex items-center gap-[15px] px-[10px] py-2 border border-[#EAECF0] rounded-[8px] mt-2">
                              <ColorPickerDefault @update:modelValue="onBrandColorChange" v-model="$settings.customizer.design.brand_color" inputClass="w-12" />
                              <!-- <div class="text-[#101828] text-lg font-medium">{{ $settings.customizer.design.brand_color }}</div> -->
                              <input type="text" v-model="$settings.customizer.design.brand_color" class="w-[calc(100%-78px)] text-[#101828] text-lg font-medium border-none outline-none">
                           </div>
                        </div>
                        <div>
                           <div class="text-[#344054] text-sm font-medium">Title Font</div>
                           <div
                              class="flex items-center gap-[15px] px-[10px] py-2 border border-[#EAECF0] rounded-[8px] mt-2">
                              <ColorPickerDefault v-model="$settings.customizer.design.typography_title_font_color" class="w-12" />
                              <!-- <div class="text-[#101828] text-lg font-medium">{{$settings.customizer.design.typography_title_font_color }}</div> -->
                              <input type="text" v-model="$settings.customizer.design.typography_title_font_color" class="w-[calc(100%-78px)] text-[#101828] text-lg font-medium border-none outline-none">
                           </div>
                        </div>
                        <div>
                           <div class="text-[#344054] text-sm font-medium">Subtitle Font</div>
                           <div
                              class="flex items-center gap-[15px] px-[10px] py-2 border border-[#EAECF0] rounded-[8px] mt-2">
                              <ColorPickerDefault v-model="$settings.customizer.design.typography_subtitle_font_color" class="w-12"/>
                              <!-- <div class="text-[#101828] text-lg font-medium">{{$settings.customizer.design.typography_subtitle_font_color }}</div> -->
                               <input type="text" v-model="$settings.customizer.design.typography_subtitle_font_color" class="w-[calc(100%-78px)] text-[#101828] text-lg font-medium border-none outline-none">
                           </div>
                        </div>
                     </div>
                  </div>

                  <div class="flex items-center gap-10 mt-10 pb-5">
                     <Button size="xl" type="secondary_gray" radius="square" classButton="!w-[180px] justify-between"
                        @click="backButton">
                        <div class="w-[70%]">Back</div>
                        <template #before>
                           <Icon name="arrowNarrowLeft" size="20px"></Icon>
                        </template>
                     </Button>
                     <Button size="xl" type="primary" radius="square" classButton="w-full justify-between"
                        @click="nextButton">
                        <div class="w-[95%]">Finish</div>
                        <template #after>
                           <Icon name="arrowNarrowRight" size="20px"></Icon>
                        </template>
                     </Button>
                  </div>
               </div>
            </div>
            <div class="hidden md:block relative w-[738px] h-[120%] overflow-hidden">
               <div class="circle-1"></div>
               <div class="circle-2"></div>
               <div class="circle-3"></div>

               <div class="text-lg font-medium text-[#344054] mt-[26px] ml-[36px] relative">Preview</div>

               <div class="w-[482px] m-auto mt-[67px] overflow-hidden bg-white relative rounded-[20px] px-10 py-[50px] shadow-[0px_10px_47px_0px_#061C3D1A]">
                  <!-- <img :src="$setup.isBusiness ? Image('setup-brand-business.png'): Image('setup-brand-personal.png')" /> -->
                  <Icon v-if="!$settings.business.full_logo_url" name="logoLight" height="80px" width="auto" class="text-[#101828]" />
                  <img v-if="$settings.business.full_logo_url" :src="$settings.business.full_logo_url" class="h-[40px]" />

                  <div class="text-[28px] font-semibold text-[#101828] mt-10" :style="{'font-family': selectedFont}">{{ $settings.addons.staffs ? $settings.business.name : $settings.business.provider_display_name }}</div>
                  <div class="text-base text-[#667085] mt-5" :style="{'font-family': selectedFont}">{{ $settings.business.about }}</div>
                  <Button class="w-[227px] mt-10" :style="{'font-family': selectedFont}" size="2xl" type="primary" radius="square">Finish</Button>
               </div>
            </div>
         </div>
      </template>
   </Modal>
</template>

<style>
.setup-set-color .vc-color-wrap{
   width: 48px !important;
   height: 48px !important;
}
/* .setup-set-color{
} */
</style>
